/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import {
    Route,
    Link
} from "react-router-dom";

/**
 * region for styles*/
import { menuMiniSiteStyle } from './style/menuMiniSiteStyle';

const MenuLink = ({ children, to, exact, classes }) => (
    <Route path={to} exact={exact} children={({ match }) => (
        <div className={match ? 'active' : ''}>
            <Link to={to}>
                <ListItem>
                    <ListItemText className={classes.cursorPointer} primary={
                        <div className={classes.containerTextAndMark}>
                            {match ? <div className={classes.mark} /> : ''}
                            <Typography className={clsx(match ? classes.isTextChecked : classes.isTextNoChecked)} variant="subtitle1">{children}</Typography >
                        </div>
                    } />
                </ListItem>
            </Link>
        </div>
    )} />
)

class MenuMiniSite extends Component {

    render() {

        const { classes } = this.props;
        return (
            <List className={classes.paddingTop}>
                <MenuLink to="/LayoutMiniSite/List" classes={classes}>
                    LIST MINI-SITES
                 </MenuLink>
                <MenuLink to="/LayoutMiniSite/Wizart" classes={classes}>
                    NEW MINI-SITE
                </MenuLink>
            </List>
        );
    }
}
MenuMiniSite.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(menuMiniSiteStyle)(MenuMiniSite);